import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Maybe} from '../../../graphql/generated/types';
import {Text} from '../../atoms/Text/Text';

export interface LineBannerProps extends HTMLAttributes<HTMLDivElement> {
  bannerTitle: Maybe<string>;
  subTitle: Maybe<string>;
  bgColor: Maybe<string>;
  rightImage: Maybe<string>;
}

export function LineBanner({
  bannerTitle,
  subTitle,
  bgColor,
  rightImage,
  className,
  ...rest
}: LineBannerProps) {
  return (
    <div
      className={twMerge([
        'relative flex h-64pxr w-full cursor-pointer overflow-hidden rounded-8pxr',
        className,
      ])}
      style={{
        background: bgColor ?? '',
      }}
      {...rest}
    >
      <div className="flex flex-1 flex-col justify-center py-13pxr pl-15pxr text-static-mono-white ">
        <Text className="font-medium2-bold pb-2pxr line-clamp-1">
          {bannerTitle}
        </Text>
        <Text className="font-small2 opacity-50 line-clamp-1">{subTitle}</Text>
      </div>
      {rightImage && (
        <img
          alt="우측 이미지"
          src={rightImage}
          className="absolute right-0 h-64pxr"
        />
      )}
    </div>
  );
}
